/**
 * นับ "เครื่องมี S/N" ในฟอร์มสัญญาเช่า — ใช้เตือน (ไม่บล็อก) เมื่อสัญญาเดียวมีหลายเครื่อง
 *
 * มติเจ้าของโปรเจกต์ 10 ต.ค. 2026: **1 เครื่อง = 1 สัญญา** (prod 849/851 สัญญามีรายการเดียว ·
 * ผู้ใช้แยกสัญญาเองอยู่แล้ว) — ใบงานเตรียมเครื่องแปลงเป็นสัญญาต่อเครื่อง ส่วนหน้าสร้าง/แก้ไขสัญญา
 * ยังให้รวมหลายเครื่องได้ (ตั้งใจเป็นชุด) แต่ต้องเตือนให้รู้ตัว เพราะยกเลิก/คืน/มัดจำต่อเครื่องยากขึ้น
 *
 * - ข้ามรายการเช่า Software อย่างเดียว และรายการที่ยังไม่เลือกเครื่อง
 * - เครื่องที่รู้ว่า `is_serialized === false` (ของนับจำนวน) ไม่นับ
 * - หาเครื่องใน list ไม่เจอ / ไม่รู้ค่า is_serialized → นับไว้ก่อน (ค่าตั้งต้นของอุปกรณ์คือมี S/N)
 * - device_id ซ้ำนับครั้งเดียว (ซ้ำเป็น validation error แยกอยู่แล้ว)
 */
export interface SerializedCountItem {
  device_id?: number | '' | null;
  is_software_only?: boolean;
}

export interface SerializedCountDevice {
  id: number;
  is_serialized?: boolean;
}

export function countSerializedDevices(
  items: SerializedCountItem[],
  devices: SerializedCountDevice[],
): number {
  const seen = new Set<number>();
  for (const item of items) {
    if (item.is_software_only || !item.device_id) continue;
    const id = Number(item.device_id);
    const device = devices.find((d) => d.id === id);
    if (device && device.is_serialized === false) continue;
    seen.add(id);
  }
  return seen.size;
}

export const MULTI_SERIALIZED_WARNING =
  'สัญญานี้มีอุปกรณ์มี S/N มากกว่า 1 เครื่อง — ปกติ 1 เครื่อง = 1 สัญญา ' +
  '(ยกเลิก/คืน/มัดจำแยกต่อเครื่องได้ง่ายกว่า) ถ้าตั้งใจรวมเป็นชุดก็บันทึกต่อได้';
